// @flow

import * as React from "react";
import cx from "classnames";

import styles from "./Card.scss";

type CardProps = {
  additionalCardStyles: string,
  children: React.Node,
  action: () => React.Node
} & React.ElementProps<HTMLDivElement>;

const Card = ({ action, additionalCardStyles, children, ...restProps }: CardProps) => (
  <div className={cx(styles.card, additionalCardStyles)} data-testid="cardComponent" {...restProps}>
    {children}
    <div className={styles.action}>{action()}</div>
  </div>
);

Card.defaultProps = {
  action: () => null,
  additionalCardStyles: ""
};

export default Card;
